// When user hits the 'Create link' button, a function inside a zustand store gets triggered, which collects current data in the store and hits an endpoint (cloudflare function). the endpoint returns url or error.

// --------------------------------------------------------------------------------

export default function share(get) {
	return {
		generateShareLink: async () => {
			try {
				// Gather the relevant state
				const stateToShare = {
					// Organism
					organism: get().organism,

					// Neurodynamics Experiments Array
					neurodynamicsExperimentsArr: get().neurodynamicsExperimentsArr,
					// Include the counter if you want to preserve the next display number
					neurodynamicsExpCounter: get().neurodynamicsExpCounter,

					// Connectomics Experiments Array
					connectomicsExperimentsArr: get().connectomicsExperimentsArr,
					// Include the counter
					connectomicsExpCounter: get().connectomicsExpCounter,

					// Computational Neuroscience
					compNeuroBrainCoverage: get().compNeuroBrainCoverage,
					neuronalAccuracy: get().neuronalAccuracy,
					simulationSpeed: get().simulationSpeed,
					speedFactor: get().speedFactor,
					modulatoryFactors: get().modulatoryFactors,

					// Projections
					techProgress: get().techProgress,
					investment: get().investment,
					yearsToCompletion: get().yearsToCompletion,
				};

				// --------------------------------------------------------------------------------

				// Make the API call
				const res = await fetch("/api/create-link", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(stateToShare),
				});

				// Check for NON-200 OK status
				// This means status is 400–599
				if (!res.ok) {
					return {
						success: false,
						copied: null,
						shareUrl: null,
						errorType: "api",
						errorMessage:
							"Could not create link due to server error. Please try again.",
					};
				}

				// --------------------------------------------------------------------------------

				// If 200 OK, try to parse success response
				let data;

				try {
					data = await res.json();
					//
				} catch (jsonParseError) {
					return {
						success: false,
						copied: null,
						shareUrl: null,
						errorType: "api--invalid-response",
						errorMessage:
							"Could not create link due to an invalid response from the server. Please try again.",
					};
				}

				// --------------------------------------------------------------------------------

				// If OK, try to copy url to clipboard
				if (data?.shareUrl) {
					try {
						// copy url to clipboard
						await navigator.clipboard.writeText(data.shareUrl);
						// Successfully fetched and copied
						return {
							success: true,
							copied: true,
							shareUrl: data.shareUrl,
							errorType: null,
							errorMessage: null,
						};
						//
					} catch (copyError) {
						// Successfully fetched, but copy failed
						return {
							success: true,
							copied: false,
							shareUrl: data.shareUrl,
							errorType: "clipboard",
							errorMessage:
								"Link is ready, but could not copy to clipboard. Please try a different browser or device.",
						};
					}
				}

				// else no data.shareUrl or data is null
				return {
					success: false,
					copied: null,
					shareUrl: null,
					errorType: "api--no-url",
					errorMessage:
						"Could not create link due to no URL in server response. Please try again.",
				};

				// --------------------------------------------------------------------------------
			} catch (err) {
				// This happens if fetch fails due to a network error
				return {
					success: false,
					copied: null,
					shareUrl: null,
					errorType: "network",
					errorMessage:
						"Could not create link due to network error. Please try again later.",
				};
			}
		},
	};
}
